// txycos.js 完整修正版
// 注意：浏览器端 SDK 推荐用 require 或 import 直接引入，避免路径问题
var COS = require('cos-js-sdk-v5');

// 增加实例创建异常捕获，确保返回合法对象
export function client() {
  try {
    const cosClient = new COS({
      region: 'ap-hongkong', // 已修正：无 cos. 前缀
      SecretId: 'IKIDCINMSZUBj5HSUyJWaS9k3Ol2eHpS4a3M',
      SecretKey: 'FKBxrY1WzHQM4atyrfKmBnJeoposuqgL',
      bucket: 'unishow-live-1383640469',
      secure: true,
      cname: false,
      endpoint: 'https://cos.ap-hongkong.myqcloud.com'
    });

    // 验证实例是否有效
    if (!cosClient || typeof cosClient.putObject !== 'function') {
      throw new Error('COS 实例初始化失败，缺少 putObject 方法');
    }

    return cosClient;
  } catch (err) {
    console.error('COS 客户端创建异常：', err);
    // 返回空对象避免后续报错扩散
    return null;
  }
}

export const getFileNameUUID = () => {
  function rx() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  return `${+new Date()}_${rx()}${rx()}`;
};


// WEBPACK FOOTER //
// ./src/common/js/txycos.js